module.exports = __webpack_public_path__ + "6e27edd1.svg";